// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"27":"5cda0169","117":"c9a690d9","156":"98814046","382":"7f439103","482":"7930d2a5","640":"fa28feaf","835":"2bc03b83","877":"3a9a2599"}[chunkId] + ".css";
};